import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'AddAddressForm';

/**
 * Errors related to the Addresses page
 */
export const Errors = createErrors<Page, Component>('AddressBook')({
    AddAddressForm: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to add address',
        },
    },
});
